import { onValue, ref } from "firebase/database";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { database } from "../firebaseConfig";
import ProgressTracker from "./ProgressTracker";
import ProgressBar from "./ProgressBar";

const Dashboard = ({ user }) => {
  const [showCourse, setShowCourse] = useState(false);
  const [showTracker, setShowTracker] = useState(false);
  const [showDefault, setShowDefault] = useState(true);
  const [courses, setCourses] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const studentCoursesRef = ref(database, `studentCourses`);
    onValue(studentCoursesRef, (snapshot) => {
      const coursesData = snapshot.val();
      if (coursesData) {
        const coursesArray = Object.values(coursesData);
        setCourses(coursesArray);
      } else {
        setCourses([]);
      }
    });
  }, [user.uid]);

  const handleShowCourse = () => {
    setShowCourse(true);
    setShowTracker(false);
    setShowDefault(false);
    setSidebarOpen(false);
  };

  const handleShowTracker = () => {
    setShowTracker(true);
    setShowCourse(false);
    setShowDefault(false);
    setSidebarOpen(false);
  };

  const handleDashboard = () => {
    setShowDefault(true);
    setShowCourse(false);
    setShowTracker(false);
    setSidebarOpen(false);
  };

  return (
    <div>
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        data-drawer-target="default-sidebar"
        data-drawer-toggle="default-sidebar"
        aria-controls="default-sidebar"
        type="button"
        className="inline-flex items-center p-2 mt-2 ms-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
      >
        <span className="sr-only">Open sidebar</span>
        <svg
          className="w-6 h-6"
          aria-hidden="true"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            clip-rule="evenodd"
            fill-rule="evenodd"
            d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
          ></path>
        </svg>
      </button>

      <aside
        id="default-sidebar"
        className={`fixed top-0 left-0 z-40 w-64 h-screen transition-transform ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        } sm:translate-x-0 bg-gray-50 dark:bg-gray-800`}
        aria-label="Sidebar"
      >
        <div className="h-full px-3 py-4 overflow-y-auto bg-gray-50 dark:bg-gray-800">
          <div className="text-right block md:hidden lg:hidden">
            <button
              type="button"
              class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
              data-modal-hide="static-modal"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              <svg
                class="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span class="sr-only">Close modal</span>
            </button>
          </div>
          <ul className="space-y-2 font-medium">
            <li>
              <button
                onClick={handleDashboard}
                className="flex items-center p-2  w-full text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
              >
                <svg
                  className="w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 22 21"
                >
                  <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z" />
                  <path d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z" />
                </svg>
                <span className="ms-3">Dashboard</span>
              </button>
            </li>
            <li>
              <button
                onClick={handleShowCourse}
                className="flex items-center w-full p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
              >
                <svg
                  className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 18 18"
                >
                  <path d="M6.143 0H1.857A1.857 1.857 0 0 0 0 1.857v4.286C0 7.169.831 8 1.857 8h4.286A1.857 1.857 0 0 0 8 6.143V1.857A1.857 1.857 0 0 0 6.143 0Zm10 0h-4.286A1.857 1.857 0 0 0 10 1.857v4.286C10 7.169 10.831 8 11.857 8h4.286A1.857 1.857 0 0 0 18 6.143V1.857A1.857 1.857 0 0 0 16.143 0Zm-10 10H1.857A1.857 1.857 0 0 0 0 11.857v4.286C0 17.169.831 18 1.857 18h4.286A1.857 1.857 0 0 0 8 16.143v-4.286A1.857 1.857 0 0 0 6.143 10Zm10 0h-4.286A1.857 1.857 0 0 0 10 11.857v4.286c0 1.026.831 1.857 1.857 1.857h4.286A1.857 1.857 0 0 0 18 16.143v-4.286A1.857 1.857 0 0 0 16.143 10Z" />
                </svg>
                <span className="flex-1 ms-3 text-left">Courses</span>
              </button>
            </li>
            <li>
              <button
                onClick={handleShowTracker}
                className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
              >
                <svg
                  className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="m17.418 3.623-.018-.008a6.713 6.713 0 0 0-2.4-.569V2h1a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1v2H9.89A6.977 6.977 0 0 1 12 8v5h-2V8A5 5 0 1 0 0 8v6a1 1 0 0 0 1 1h8v4a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-4h6a1 1 0 0 0 1-1V8a5 5 0 0 0-2.582-4.377ZM6 12H4a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Z" />
                </svg>
                <span className="flex-1 ms-3 whitespace-nowrap">
                  Progress Tracker
                </span>
              </button>
            </li>
            <li>
              <Link
                to="/"
                className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
              >
                <svg
                  className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.96 2.96 0 0 0 .13 5H5Z" />
                  <path d="M6.737 11.061a2.961 2.961 0 0 1 .81-1.515l6.117-6.116A4.839 4.839 0 0 1 16 2.141V2a1.97 1.97 0 0 0-1.933-2H7v5a2 2 0 0 1-2 2H0v11a1.969 1.969 0 0 0 1.933 2h12.134A1.97 1.97 0 0 0 16 18v-3.093l-1.546 1.546c-.413.413-.94.695-1.513.81l-3.4.679a2.947 2.947 0 0 1-1.85-.227 2.96 2.96 0 0 1-1.635-3.257l.681-3.397Z" />
                  <path d="M8.961 16a.93.93 0 0 0 .189-.019l3.4-.679a.961.961 0 0 0 .49-.263l6.118-6.117a2.884 2.884 0 0 0-4.079-4.078l-6.117 6.117a.96.96 0 0 0-.263.491l-.679 3.4A.961.961 0 0 0 8.961 16Zm7.477-9.8a.958.958 0 0 1 .68-.281.961.961 0 0 1 .682 1.644l-.315.315-1.36-1.36.313-.318Zm-5.911 5.911 4.236-4.236 1.359 1.359-4.236 4.237-1.7.339.341-1.699Z" />
                </svg>
                <span className="flex-1 ms-3 whitespace-nowrap">
                  Explore Courses
                </span>
              </Link>
            </li>
          </ul>
        </div>
      </aside>

      <div className="p-4 sm:ml-64">
        <div className="p-4 border-2 border-gray-200 border-dashed rounded-lg dark:border-gray-700">
          {showCourse && (
            <div>
              {courses.length === 0 ? (
                <div className="my-3 flex justify-center">
                  <img src="/empty.png" alt="empty" />
                </div>
              ) : (
                <div className="grid grid-cols-1 gap-4 ">
                  {courses.map((courseObj) =>
                    Object.entries(courseObj).map(([courseId, course]) => (
                      <div key={courseId} className="my-3">
                        <button className="w-full h-full">
                          <Link
                            to={`/courses/${course.id}`}
                            className="block w-full h-full p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700"
                          >
                            <div className="lg:flex lg:items-stretch">
                              <div>
                                <img
                                  className="object-cover w-full h-40 rounded-lg"
                                  src={course.thumbnail}
                                  alt={course.courseName}
                                />
                              </div>
                              <div className="flex-1 text-left mt-4 lg:mt-0 lg:ml-10">
                                <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                                  {course.courseName}
                                </h5>
                                <p className="font-normal text-gray-700 dark:text-gray-400">
                                  <strong>Instructor:</strong>{" "}
                                  {course.instructor}
                                </p>
                                <p className="font-normal text-gray-700 dark:text-gray-400">
                                  <strong>Description:</strong>{" "}
                                  {course.description}
                                </p>
                                <p className="font-normal text-gray-700 dark:text-gray-400">
                                  <strong>Due date:</strong> {course.due_date}
                                </p>
                                <div className="mt-4">
                                  <ProgressBar course={course.ProgressStatus} />
                                </div>
                              </div>
                            </div>
                          </Link>
                        </button>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          )}
          {showTracker && <ProgressTracker courses={courses} />}
          {showDefault && (
            <div className="bg-gray-100">
              <div className="font-bold text-3xl text-center pt-5">
                {user.displayName
                  ? `${user.displayName}'s Dashboard`
                  : "Student Dashboard"}
              </div>
              <div className="flex justify-center ">
                <img
                  src="/dashboard.png"
                  alt="dashboard"
                  className="h-[15rem] pt-10"
                />
              </div>
              <div className="flex justify-center">
                <div className="w-1/2 text-center my-10">
                  <p className="hidden md:block">
                    Welcome to your student dashboard! Here, you can easily
                    access and manage your enrolled courses. View course details
                    like name, instructor, and progress, and mark courses as
                    completed. Stay organized and focused on your academic
                    journey effortlessly!
                  </p>
                  <p className="pt-3 text-xs md:text-sm font-bold">
                    Discover your course progress and more by simply clicking
                    the sidebar button! 🚀 Explore with ease!{" "}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
